import request from '@/api/request.js'

// 新增
export function PaperCategoryInsert(data) {
    return request({
        url: '/api/paper/papercategoryinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function PaperCategoryDelete(id) {
    return request({
        url: `/api/paper/papercategorydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function PaperCategoryUpdate(id, data) {
    return request({
        url: `/api/paper/papercategoryupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function PaperCategoryGetById(id) {
    return request({
        url: `/api/paper/getpapercategorybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function PaperCategoryGetList(params) {
    return request({
        url: '/api/paper/getpapercategorylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function PaperCategoryGetPageList(params) {
    return request({
        url: '/api/paper/getpapercategorypagelist',
        method: 'get',
        params: params
    })
}